import { camelizeKeys } from 'humps';
import { api, endpoints } from '@dom/utils';

import { reduxDB } from '../redux';

const fetchGuideData = async (id) => {
  try {
    const { data } = await api.get(endpoints.profile.getUserData(id));
    const camelizedData = camelizeKeys(data);
    reduxDB.guides.replace(camelizedData);
    return camelizedData;
  } catch (e) {
    // Handle error.
    console.log(e);
  };
};

export default fetchGuideData;
